export default __webpack_public_path__ + "static/media/ecal_icon_purple_light.c13bba78.svg";